import { render, staticRenderFns } from "./RegistryFormTab.vue?vue&type=template&id=f2e19704"
import script from "./RegistryFormTab.vue?vue&type=script&lang=js"
export * from "./RegistryFormTab.vue?vue&type=script&lang=js"
import style0 from "./RegistryFormTab.vue?vue&type=style&index=0&id=f2e19704&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports